module.exports = {
	"getNotified": "Get notified",
	"launchingSoon": "Be ready, we are launching soon!",
	"slogan": "Connecting people to live auctions worldwide.",
	"success": "You'll be notified about our platform launch! See you soon!",
	"wedo": "We build and enable advanced solutions for auctioneers and sellers.",
	"errors": {
		"alreadySubscribed": "You are already subscribed!"
	}
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/en/comingSoon.json5
// module id = 1923
// module chunks = 6